import React, { useState, useEffect } from "react";
import ConfigContext, { Config } from "./config-context";
import { Spinner } from "@cloudscape-design/components";
import axios from "axios";
import { getOIDCRedirectURL } from "@/utils/utils";
import { RCH_CONFIG_DATA } from "@/utils/const";

interface ConfigProviderProps {
  children: React.ReactNode;
}

const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  const [config, setConfig] = useState<Config | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const publicUrl = process.env.PUBLIC_URL ?? "";
        const configUrl = `${publicUrl}/aws-exports.json`;
        // get system configuration
        const resConfig = await axios.get(configUrl);
        const configData = resConfig.data as Config;
        window.localStorage.setItem(
          RCH_CONFIG_DATA,
          JSON.stringify(configData)
        );
        await axios
          .get(
            `${configData.aws_oidc_provider}/.well-known/openid-configuration`
          )
          .then((oidcRes: any) => {
            configData.aws_oidc_logout_url = oidcRes.data.end_session_endpoint;
            configData.aws_oidc_redirect_url = getOIDCRedirectURL(
              configData.aws_cloudfront_url,
              configData.aws_oidc_customer_domain
            );
            setConfig(resConfig.data);
          });
      } catch (error) {
        console.error("error:", error);
      }
    };
    fetchConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!config) {
    return (
      <div className="page-loading">
        <Spinner />
      </div>
    );
  }

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};

export default ConfigProvider;
